import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import parse, {domToReact} from 'html-react-parser';

import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';
import {ProductSupportBookmarkIcon} from '@amblique/king-living/app/components/icons';

/**
 * Renders pimlyProductSupport HTML from BM. Anchor tags get SemiBold + bookmark icon (Figma 7730:59198).
 */
const ProductSupportAccordionContent = ({html}) => {
  const styles = useMultiStyleConfig('ProductDetail', {});

  const content = useMemo(() => parse(html, {
    replace(domNode) {
      if (domNode.type !== 'tag' || domNode.name !== 'a') {
        return undefined;
      }

      const {href, target, rel, title} = domNode.attribs ?? {};

      if (!href) {
        return undefined;
      }

      return (
        <Box
          as="a"
          href={href}
          rel={rel || 'noopener noreferrer'}
          target={target || '_blank'}
          title={title}
          {...styles.productSupportLink}
        >
          {domToReact(domNode.children)}
          <ProductSupportBookmarkIcon aria-hidden boxSize="12px" flexShrink={0} />
        </Box>
      );
    },
  }), [html, styles.productSupportLink]);

  return (
    <Box
      as="div"
      className="product-support-accordion-content"
      {...styles.specificationsAccordionContentProductSupport}
    >
      {content}
    </Box>
  );
};

ProductSupportAccordionContent.propTypes = {
  html: PropTypes.string.isRequired,
};

export default ProductSupportAccordionContent;
